import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import Modal from '@cloudscape-design/components/modal';
import Input from '@cloudscape-design/components/input';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import FormField from '@cloudscape-design/components/form-field';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
	playerBanEditModalStore, playerHidePaywayEditModalStore,
} from "../stores/playerHidePaywayEditModal";
import { Container } from "react-bootstrap";
import Select from "@cloudscape-design/components/select";
import DatePicker from "@cloudscape-design/components/date-picker";

class PlayerHidePaywayEditModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		}
	}


	resetFormFields = () => {
		const { setPlayerHidePaywayEditModal, playerHidePaywayEditModal } = this.props;
		setPlayerHidePaywayEditModal({
			...playerHidePaywayEditModal,
			show: false,
			loaded: false,
			uid: false,
			reason: "",
			banType: false,
			date: false,
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateFormField = (key, value) => {
		const { playerHidePaywayEditModal, setPlayerHidePaywayEditModal } = this.props;
		const updatedState = cloneDeep(playerHidePaywayEditModal);
		updatedState[key] = value;
		setPlayerHidePaywayEditModal(updatedState);
	};

	editPlayerBan = async () => {
		const { playerHidePaywayEditModal, Interface } = this.props;


		try {
			const body = {
				...playerHidePaywayEditModal,
				banType: playerHidePaywayEditModal?.banType?.value
			};

			this.setState({
				loading: true,
			});

			const result = await Interface.request('set', {
				class: 'data',
				module: 'playerHidePayway',
				method: 'edit',
			}, body);

			Interface.addNoty('Success', 'Player hide payway edit successfully');
			Interface.loadPlayerHidePayway();
			this.resetFormFields();
		} catch (error) {
			Interface.addNoty('Error', error.text || error.toString());
		} finally {
			this.setState({
				loading: false,
			});
		}
	};

	render() {
		const { playerHidePaywayEditModal, setPlayerHidePaywayEditModal } = this.props;

		return (
			<Modal
				visible={playerHidePaywayEditModal.show}
				size="medium"
				onDismiss={() => setPlayerHidePaywayEditModal({ ...playerHidePaywayEditModal, show: false })}
				header="Add Player ban"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button variant="normal" onClick={this.resetFormFields}>
								Cancel
							</Button>
							<Button disabled={this.state.loading} loading={this.state.loading} variant="primary" onClick={this.editPlayerBan}>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				<Container>
					<SpaceBetween direction="vertical" size="m">
						<FormField
							label="Uid"
							description="User uid"
							stretch
						>
							<Input
								type="number"
								value={playerHidePaywayEditModal.uid}
								onChange={({ detail }) =>
									this.updateFormField("uid", detail.value)
								}
								placeholder="1"
								inputMode="numeric"
							/>
						</FormField>

						<FormField
							label="Group Required"
							description="Group translation"
							stretch
						>
							<Input
								type="text"
								value={playerHidePaywayEditModal.group}
								onChange={({ detail }) =>
									this.updateFormField(
										"group",
										detail.value === ""
											? ""
											: detail.value
									)
								}
								placeholder="group"
								inputMode="text"
							/>
						</FormField>
						<FormField label="Select ban type"
											 stretch>
							<Select
								filteringType="auto"
								placeholder="Ban type"
								selectedOption={playerHidePaywayEditModal.banType}
								onChange={({ detail }) => this.updateFormField("banType", detail.selectedOption)}
								options={[{ value: "forbidden", label: "Forbidden" }, { value: "date", label: "Date" }]}
								stretch
							/>
						</FormField>
						{playerHidePaywayEditModal.banType?.value === "date" && <FormField
							label="Till"
							description="Ban till"
							stretch
						>
							<DatePicker
								onChange={({ detail }) => this.updateFormField("date", detail.value)}
								value={playerHidePaywayEditModal.date}
								openCalendarAriaLabel={selectedDate =>
									"Choose certificate expiry date" +
									(selectedDate
										? `, selected date is ${selectedDate}`
										: "")
								}
								placeholder="YYYY/MM/DD"
								nextMonthAriaLabel={""} previousMonthAriaLabel={""} todayAriaLabel={""}/>
						</FormField>}

					</SpaceBetween>
				</Container>
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const playerHidePaywayEditModal = useRecoilValue(playerHidePaywayEditModalStore);
		const setPlayerHidePaywayEditModal = useSetRecoilState(playerHidePaywayEditModalStore);

		return (
			<Component
				{...props}
				setPlayerHidePaywayEditModal={setPlayerHidePaywayEditModal}
				playerHidePaywayEditModal={playerHidePaywayEditModal}
			/>
		);
	};
}

export default withRecoil(PlayerHidePaywayEditModal);